import React from "react"
import { Button, FormControl, Spinner } from "react-bootstrap"
import { FaEnvelope } from "react-icons/fa"
import Util from "../util/Util";
import withRouter from "../util/WithRouter";
import LoginAPI from "../api/LoginAPI";
import { Link } from "react-router-dom";

const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

class ResetPasswordPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = { email: "", isLoading: false  }
  }

  onChangeEmail = event => this.setState({...this.state, email: event.target.value});

  onSubmitClick = () => {
    if(!this.state.email) return
    // Validate email
    const isValidEmail = EMAIL_REGEX.test(this.state.email.trim())
    if(!isValidEmail) {
      Util.showNotification("Invalid Field", "Please check your email", "danger")
      return
    }
    this.setState({...this.state, isLoading: true})
    LoginAPI.resetPassword(this.state.email.trim(), this.onResponse, this.failure);
  }

  onResponse = res => {
    this.setState({...this.state, isLoading: false, email: '' });
    Util.showNotification("Email sent", res.message, "success", () => this.props.navigate("/"), 10000)
  }

  failure = res => {
    this.setState({...this.state, isLoading: false });
    Util.showNotification("Email already sent", res.message, "success");
  }

  render() {
    return ( 
      <div className="container-fluid d-flex align-items-center justify-content-center min-vh-100 p-3"
        style={{backgroundImage: "url(/images/admin-2.png)"}}
      >
        <div className="reset-card">
          <div className="logo-section">
              <div className="d-inline-flex align-items-center justify-content-center text-white fw-semibold fs-6 mb-3 logo-placeholder">
                <img className=" client_logo_login_logout"
                  src={process.env.PUBLIC_URL + "/images/logo.png"}
                  alt="Logo" 
                />
              </div>
              <h2 className="reset-title">Reset Password</h2>
              <p className="reset-subtitle">Enter your email address and we'll send you a link to reset your password.</p>
          </div>
          
          <form id="reset-form">
              <div className="input-group">
                <span className="input-icon">
                    <FaEnvelope className="iconusers" />
                </span>
                  <FormControl
                    type="text"
                    autoComplete="off"
                    autoFocus="on"
                    placeholder="Email"
                    className="form-control py-2"
                    value={this.state.email}
                    onChange={this.onChangeEmail}
                    required
                  />
              </div>
              
              <Button
                className="mt-3  btn-md w-100 submit-btn"
                onClick={this.onSubmitClick}
                color="#098dcb"
                disabled={this.state.isLoading}
              >
                {this.state.isLoading &&  
                  <Spinner animation="border" role="loading" size="sm" className="me-2">
                    <span  className="visually-hidden">Loading...</span>
                  </Spinner>
                }
                Submit
              </Button>
          </form>
          
          <div className="text-center mt-3">
              <Link to={"/"} >
                Back to login
              </Link>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(ResetPasswordPage)